import * as ActionTypes from "../actions/types";

const INITIAL_STATE = {
  queue: [],
  show: false,
  mode: null,
  size: null,
  defaultDateTime: null,
  callback: null,
};

function requestDateTime(state, action) {
  const { mode, size, callback, defaultDateTime } = action.payload;
  state.show = true;
  state.mode = mode;
  state.size = size;
  state.defaultDateTime = defaultDateTime;
  state.callback = callback;
}

function requestDateTimeComplete(state) {
  state.queue = [];
  state.show = false;
  state.mode = null;
  state.size = null;
  state.defaultDateTime = null;
  state.callback = null;
}

export const dateTime = {
  initialState: INITIAL_STATE,
  handlers: {
    [ActionTypes.REQUEST_DATETIME]: requestDateTime,
    [ActionTypes.REQUEST_DATETIME_COMPLETE]: requestDateTimeComplete,
  },
};
